import { isFeatureEnabled } from '@lumapps/features';

/** Check the new interface routing is enabled (force redirect to layout v2 when possible). */
export const isNewInterfaceRoutingEnabled = isFeatureEnabled('new-interface-routing');
